import { render, staticRenderFns } from "./delivery-schedule.vue?vue&type=template&id=3c0cd1ce&"
import script from "./delivery-schedule.vue?vue&type=script&lang=js&"
export * from "./delivery-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports